// extracted by mini-css-extract-plugin
export default {"container":"Clients_container__8jmpF","title":"Clients_title__WfTSR","list":"Clients_list__b57Pb","item":"Clients_item__PTFDe"};